import React from 'react';
import { Table } from '@cordata/buffet';
import { useParams, useHistory } from 'react-router-dom';

const MedicalEventTable = (p) => {
  const history = useHistory();
  const params = useParams();

  const destination = (data) => {
    const patientUid = params
      ? params.patient_id
      : data.relationships.summaryPatient.attributes.patientUid;

    let details = 'details';

    if (data.attributes.medicalEventName === 'cit') {
      details = 'cit-details';
    }

    return `/patients/${patientUid}/medical-events/${data.attributes.medicalEventName}/${data.id}/${details}`;
  };

  return (
    <Table
      {...p}
      columns={p.columns}
      getTrProps={(state, rowInfo) => ({
        style: {
          cursor: 'pointer',
        },
        onClick: (e, handleOriginal) => (
          handleOriginal
          ? handleOriginal()
          : !rowInfo.original.isForeign
            ? history.push(destination(rowInfo.original))
            : null
        ),
      })}
    />
  );
};

export default MedicalEventTable;
